import { render } from "./CreateGame.vue?vue&type=template&id=3fc86812&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"

import "./CreateGame.vue?vue&type=style&index=0&id=3fc86812&scoped=true&lang=css"
import "./CreateGame.vue?vue&type=style&index=1&id=3fc86812&lang=scss"
import "./CreateGame.vue?vue&type=style&index=2&id=3fc86812&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc86812"]])

export default __exports__